/**
 * A type representing the current state while solving the puzzle.
 */
// eslint-disable-next-line import/prefer-default-export
export enum AnswerState {
  INITIAL,
  COMPLETED_UNRESOLVED,
  COMPLETED_SUCCESS,
  COMPLETED_ERROR
}
